<template>
    <div>
        <b-button
          style="position: absolute; right: 20px; top: 30vh"
          type="is-primary"
          @click="printArea('printAreaDiv')">
          Imprimir relatório
        </b-button>

        <div class="" id="printAreaDiv" >
          <div class="level mb-0">
            <div class="level-left" >
              <img src="../assets/logo-2.png" style="width: 100vw; max-height: 20vh">
              <div class="d-flex top-info">
                Cliente: {{getClientName()}}<br>
                
              </div>

              <div class="d-flex top-info-2">
                Período: {{this.dateSD }} - {{this.dateED}}
              </div>

              <div class="d-flex top-info-user">
                Responsável: 
              </div>
              
          </div>
            
          </div>
            
            
        <div class="graphContainer">
          <div class="boxGraph">
            <div class="box" style="height: 2300px">
              <div class="is-flex is-flex-direction-row-reverse">
                <div class="top-datepicker datepicker" id="datepickerMobile">
                      <b-field label="Selecione o Período" label-position="on-border">
                        <b-datepicker
                          v-model="dates"
                          range
                          :mobile-native="false"
                          :date-formatter="dateConverter"
                          @input="selectDate()"
                          icon="calendar-day"
                          style="width: 240px"
                          position="is-bottom-left"
                        >
                        </b-datepicker>
                      </b-field>
                    </div>
              </div>

              <div class="d-flex justify-center mt-2 pa-2">
                  <h5 align="center"><b>Usuários</b></h5>
              </div>
              <div class="columns">
                <div class="column is-16-mobile">
                  <div v-if="validarGraficos">

                    <div class="graficos">
                      <div class="level">
                        <h5 align="left"><b>Dia</b></h5>
                      </div>
                    
                      <apex-chart-line
                      :data="objGraficoDia"
                      :loading="this.isLoadingAuthenticated"
                    ></apex-chart-line>
                    </div>

                    <div class="graficos">
                      <div class="level">
                        <h5 align="left"><b>Semana</b></h5>
                      </div>
                        <apex-chart-line
                          :data="objGraficoSemana"
                          :loading="this.isLoadingAuthenticated"
                        ></apex-chart-line>
                    </div>

                    <div class="graficos-mes">
                      <div class="level top-graficos">
                        <h5 align="left"><b>Mês</b></h5>
                      </div>
                        <apex-chart-line
                          :data="objGraficoMes"
                          :loading="this.isLoadingAuthenticated"
                        ></apex-chart-line>
                    </div>
                  
                    <!-- <div class="graficos" style="max-width: 100px">
                      <div class="level">
                        <h5 align="left"><b>Mês</b></h5>
                      </div>
                      <apex-chart-line
                        width="100"
                        :data="objGraficoMes"
                        :loading="this.isLoadingAuthenticated"
                      ></apex-chart-line>
                    </div> -->
                    <div class="graficos">
                      <apex-chart-vertical-bar-age
                        :data="barData"
                      ></apex-chart-vertical-bar-age>
                      <br>
                      <br>

                      <apex-chart-pie-gender
                        :data="pieData"
                      ></apex-chart-pie-gender>

                      <br><br>

                      <apex-chart-vertical-bar
                        :data="barAgeData"
                      ></apex-chart-vertical-bar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
        </div>
    </div>
</template>

<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapGetters, mapActions } from "vuex";
import ApexChartLine from "@/components/charts/ApexChartLine";
import ApexChartVerticalBar from "@/components/charts/ApexChartVerticalBar";
import ApexChartPieGender from "@/components/charts/ApexChartPieGender";
import ApexChartVerticalBarAge from "@/components/charts/ApexChartVerticalBarAge";

var moment = require("moment");

const ws = new Webservices();

var teste = {};
export default teste = {
  components: {
    ApexChartLine,
    ApexChartVerticalBar,
    ApexChartVerticalBarAge,
    ApexChartPieGender
  },
  data() {
    return {
      realTimeCampaigns: [],
      realTimeTotalAps: [],
      realTimeDetecteds: [0],
      realTimeApsOnline: [],
      realTimeController: {
        detecteds: false,
        apsOnline: false
      },
      granularityDia: "Dia",
      granularitySemana: "Semana",
      granularityMes: "Mes",
      selectDates: [],
      topAps: {},
      radios: [],
      apRequired: 0,
      dates: [],
      campaigns: [],
      segdata: { devices: [], online: [] },
      settings: { periodo: 24 },
      isLoadingAuthenticated: true,
      isLoadingTopAps: true,
      count_here_group: 0,
      daySelected: "",
      dateSD: "",
      dateED: "",
      birth_date_required: true,
      data: [],
      data_summary: [],
      data_news: [],
      dataNewsAux: false,
      data_questions: [],
      dataOnline: [],
      realTimeOnline: 0,
      realTimeDevices: 0,
      dataDay: [],
      idInterval: undefined,
      debug_mode: 0,
      loadIterations: 0,
      objGraficoDia: {},
      objGraficoSemana: {},
      objGraficoMes: {},
      validarGraficos: false,
      barDataArray: [],
      videoData: {},
      barData: {},
      pieData: {},
      barAgeData: {},
    };
  },

  async mounted() {
    await ws.setToken(this.getToken);

    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }

    this.openData();

    this.loadIterations = 0;
    // this.loadOnlineData();
    // this.getDetecteds();
    // this.getAps();

    //olhar se a chamada está correta

    this.idInterval = setInterval(_ => {
      if (store.state.client) {
        if (store.state.client.id == "all") {
          //this.loadOnlineGroupData();
          // this.loadGeneralGroupData();
        } else {
          // this.loadOnlineData();

          // this.getDetecteds();
          // this.getAllActiveCampaigns();
          // this.getAps();
          this.loadIterations++;
        }
      }
    }, 30 * 5 * 1000);

    ws.getClientFields(this.getID).then(response => {
      this.fields = response.data.fields.filter(
        el => el.type != "label" && el.is_active
      );
      //this.fields.push({ type: "string", name: "mac", label: "MAC" });
      this.fields = this.fields.map(el => el.name);

      ws.getClientFields(this.getID)
        .then(response => {
          this.fields = response.data.fields.filter(
            el => el.type != "label" && el.is_active
          );

          //this.fields.push({ type: "string", name: "mac", label: "MAC" });
          this.fields = this.fields.map(el => el.name);
        })
        .catch(err => {});
    });
    this.dates = [
      moment()
        .subtract(6, "d")
        .toDate(),
      moment().toDate()
    ];

    this.selectDate();
  },
  beforeDestroy() {
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }
  },
  methods: {
    ...mapActions(["logout"]),
    getController_id() {
      if (store.state.client) {
        return store.state.client.controller_id;
      } else {
        return "";
      }
    },
    getClient_id() {
      if (store.state.client) {
        return store.state.client.id;
      } else {
        return "";
      }
    },
    getClientName() {
      if (store.state.group_client_await) {
        return store.state.group_selected.text;
      } else {
        if (store.state.client) {
          return store.state.client.name;
        } else {
          return "";
        }
      }
    },
    dataByPeriod() {
      let count = 0;
      
      let startDate = moment(this.dateSD);
      let datelimit = moment(this.selectDates[1])
        .endOf("month")
        .add(6, "days");
      let dayDiff = datelimit.diff(startDate, "days") + 1;
      let daySelectedStart = moment(this.selectDates[0]).date();
      if (!dayDiff) {
        dayDiff = 0;
      }
      let totalAuthenticated = Array(dayDiff).fill(0);
      let newAuthenticated = Array(dayDiff).fill(0)

      this.data_summary.sort((a, b) => {
        return a.datetime >= b.datetime ? 1 : -1;
      });

      

      this.data_summary.forEach((element, index) => {
        element.age_ranges.forEach((quantity, indexs) => {
          totalAuthenticated[index] += quantity[0] + quantity[1] + quantity[2];
        });
      });
      newAuthenticated = this.data_news.data;

      console.log(totalAuthenticated);
      console.log(newAuthenticated);

      if (this.granularityDia == "Dia") {
        let arrayDay = [];
        let arrayDayNew = [];
        var output;
        //aqui é a parte responsável por apartir de vetor this.data que é o vetor com os dados, manipular e colocar os dados apenas dos dias escolhidos na granularidade diária mesmo no vetor array.day

        let dayStart = daySelectedStart + 5; //aqui foi definido o inicio do vetor, que como é possível olhar logo acima na criação das variáveis, ele é o dia escolhido + 5 pois na requisição temos sempre os 6 dias a mais, e no if é <=
        let dayDiffSelected = moment(this.selectDates[1]).diff(
          moment(this.selectDates[0]),
          "days"
        );
        let dayEnd = dayStart + dayDiffSelected; // é aqui que eu defino o final do vetor que é o começo + a diferença de dias entre os dias selecionados
        let arrayDateDay = [];
        count = 0;

        totalAuthenticated.forEach((element, index) => {
          if (index >= dayStart && index <= dayEnd) {
            if (newAuthenticated[index]) {
              if (element >= newAuthenticated[index]) {
                arrayDay[count] = element;
                arrayDayNew[count] = newAuthenticated[index];
              } else {
                arrayDay[count] = newAuthenticated[index];
                arrayDayNew[count] = newAuthenticated[index];
              }
            } else {
              arrayDayNew[count] = 0;
              arrayDay[count] = element;
            }
            arrayDateDay[count] = moment(this.selectDates[0])
              .add(count, "days")
              .format("DD/MM");
            count++;
          }
        });

        output = {
          total: arrayDay,
          // new: arrayDayNew,
          dates: arrayDateDay
        };

        this.data_summary.sort((a, b) => {
          return a.datetime >= b.datetime ? 1 : -1;
        });

      console.log("dia: ", output);
      
      this.objGraficoDia = output;
      }

      if (this.granularitySemana === "Semana") {
        let totalSumWeek = [];
        let totalSumWeekNew = [];
        let arrayWeek = [];
        let arrayWeekNew = [];
        var output;
        
        //aqui é a parte responsável por gerar o vetor para o granularidade semanal, ela segue uma lógica igual a anterior que é a diária, a diferença que é aqui é necessário levar em considreração
        //o dia de começo e fim da semana, que é segunda e domingo, então é basicamente a lógica da diária, só que somando e subtraindo para o primeiro dia ser sempre uma segunda e ultimo ser sempre um domingo

        const selectedStartDayofWeek = moment(this.selectDates[0]);
        const selectedEndDayofWeek = moment(this.selectDates[1]);
        let dayStartWeek = selectedStartDayofWeek.day();
        let dayEndWeek = selectedEndDayofWeek.day();
        let startWeek;
        let endWeek;

        if (dayStartWeek == 0) {
          startWeek = -6;
        } else {
          startWeek = -dayStartWeek + 1;
        }

        if (dayEndWeek == 0) {
          endWeek = 0;
        } else {
          endWeek = -dayEndWeek + 7;
        }

        let startWeekCompare = moment(this.selectDates[0]).add(
          startWeek,
          "days"
        );

        let endWeekCompare = moment(this.selectDates[1]).add(endWeek, "days");

        startWeek += daySelectedStart + 5;

        let dayDiffWeek = endWeekCompare.diff(startWeekCompare, "days");
        let endDayWeek = startWeek + dayDiffWeek;
        count = 0;

        totalAuthenticated.forEach((element, index) => {
          if (index >= startWeek && index <= endDayWeek) {
            arrayWeek;
            arrayWeek[count] = element;
            arrayWeekNew[count] = newAuthenticated[index];
            count++;
          }
        });

        //aqui é a parte responsável por pegar o array gerado na função que fica acima que é o "arrayWeek" e dividir de 7 em 7, para que assim tenha a granularidade semanal
        totalSumWeek = new Array(Math.floor(arrayWeek.length / 7)).fill(0);
        totalSumWeekNew = new Array(Math.floor(arrayWeek.length / 7)).fill(0);
        arrayWeek.forEach((element, index) => {
          if (element >= arrayWeekNew[index]) {
            totalSumWeek[Math.floor(index / 7)] += element;
            totalSumWeekNew[Math.floor(index / 7)] += arrayWeekNew[index];
          } else {
            totalSumWeek[Math.floor(index / 7)] += element;
            totalSumWeekNew[Math.floor(index / 7)] += element;
          }
        });

        let arrayDateWeek = [];

        arrayDateWeek[0] = moment(startWeekCompare).format("DD/MM"); //aqui foi criado um array responsável por receber as datas que iniciam cada semana, colocamos inicialmente a data inicial e adcionamos 7 dias sempre

        let aux = 0;
        let count;
        for (count = 1; count <= arrayWeek.length / 7; count++) {
          arrayDateWeek[count] = moment(startWeekCompare)
            .add(6 * count + aux, "days")
            .format("DD/MM");
          aux++;
        }

        output = {
          total: totalSumWeek,
          // new: totalSumWeekNew,
          dates: arrayDateWeek
        };
        
        this.data_summary.sort((a, b) => {
          return a.datetime >= b.datetime ? 1 : -1;
        });

        console.log("semana: ", output);
        
        this.objGraficoSemana = output;
      }

      if (this.granularityMes == "Mes") {
        let arrayMonth = [];
        let arrayMonthNew = [];
        let totalSumMonth = [];
        let totalSumMonthNew = [];
        var output;
        //aqui temos o mensal onde basicamente só temos que tirar os 6 dias a mais e a menos que fizemos na requisição, depois é so percorrer o vetor salvar em outro vetor

        totalAuthenticated.forEach((element, index) => {
          if (index > 5 && index < totalAuthenticated.length - 6) {
            if (element >= newAuthenticated[index]) {
              arrayMonthNew[count] = newAuthenticated[index];
              arrayMonth[count] = element;
            } else {
              arrayMonthNew[count] = element;
              arrayMonth[count] = element;
            }

            count++;
          }
        });

        //aqui é a parte responsável por pegar o array mensal gerado acima e somar cada informação de cada mês e gerar um novo array separado com a soma dos dados de cada mês
        //pra isso fazemos uso de uma função da biblioteca momment que permite que retornemos o mês, assim fica possível comparar o mês de cada dado, pq a cada repetição aumentamos um dia e assim quando
        //for passado pra outro mês começamos a salvar na outra posição do array
        count = 0;
        let sum = 0;
        let sumNew = 0;
        let countDate = moment(startDate).add(6, "days");
        let countDateMonth = moment(startDate).add(6, "days");
        let monthStart = countDate.month();
        let MonthCompare = countDateMonth.month();
        let arrayDateMonth = [];
        arrayDateMonth[0] = moment(countDateMonth).format("MM/YYYY"); //Aqui é criado o vetor que vai salvar os meses para mostrar no grafico, foi iniciado com o primeiro mês e vai adicionando o resto a cada 30 dias la no "else"

        arrayMonth.forEach((element, index) => {
          if (monthStart == MonthCompare) {
            sum += element;
            sumNew += arrayMonthNew[index];
            countDate = moment(countDate).add(1, "days");
            monthStart = countDate.month();
          } else {
            countDateMonth = moment(countDateMonth).add(1, "months");
            arrayDateMonth[count + 1] = moment(countDateMonth).format(
              "MM/YYYY"
            );
            MonthCompare = countDateMonth.month();

            totalSumMonth[count] = sum;
            totalSumMonthNew[count] = sumNew;

            sum = element;
            sumNew = arrayMonthNew[index];
            count++;
          }
        });

        totalSumMonth[count] = sum;
        totalSumMonthNew[count] = sumNew;

        output = {
          total: totalSumMonth,
          // new: totalSumMonthNew,
          dates: arrayDateMonth
        };

        this.data_summary.sort((a, b) => {
        return a.datetime >= b.datetime ? 1 : -1;
      });
      
      console.log("mes: ", output);
      this.objGraficoMes = output;
      }

      this.validarGraficos = true;
    },
    printArea(divName) {
      console.log("teste")
     // Get HTML to print from element
    const prtHtml = document.getElementById(divName).innerHTML;

    // Get all stylesheets HTML
    let stylesHtml = '';
    for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      stylesHtml += node.outerHTML;
    }

    console.log(stylesHtml);

    // Open the print window
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

    WinPrint.document.write(`<!DOCTYPE html>
    <html>
      <head>
      <title></title>
        ${stylesHtml}
      </head>
      <body>
        ${prtHtml}
      </body>
    </html>`);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    // WinPrint.close();
    },
    openData() {
      var backgroundColor = [
        "rgb(92,154,239, 0.8)",
        "rgba(71,192,235, 0.8)",
        "rgba(255,207,71, 0.8)",
        "rgba(63,207,172, 0.8)",
        "rgba(159,214,97, 0.8)",
        "rgba(253,109,75, 0.8)",
        "rgba(240,84,98, 0.8)"
      ];
      var borderColor = [
        "rgb(71,135,223)",
        "rgb(49,174,220)",
        "rgb(247,188,48)",
        "rgb(45,189,154)",
        "rgb(140,194,75)",
        "rgb(235,86,56)",
        "rgb(240,84,98)"
      ];
      var saidaModel = {
        dialog: false,
        title: "",
        visibility: true,
        tick: 0,
        data: {
          labels: [],
          datasets: [
            {
              label: "Masculino",
              backgroundColor: backgroundColor[0],
              borderColor: borderColor[0],
              borderWidth: 1,
              data: []
            },
            {
              label: "Feminino",
              backgroundColor: backgroundColor[1],
              borderColor: borderColor[1],
              borderWidth: 1,
              data: []
            }
          ]
        }
      };
      var saidaArray = [];
      
      ws.getVideo('61e1713cc666e776ff09d995').then(response => {
        var saida = {};
        var video = response.data;
        this.videoData = response.data;
        saida = JSON.parse(JSON.stringify(saidaModel));
        saida.title = video.name;
        saida.visibility = true;
        video.viewData.forEach(el => {
          saida.data.labels.push(el.label);
          saida.data.datasets[0].data[el.id] = -el.data[0];
          saida.data.datasets[1].data[el.id] = el.data[1];
          this.barDataArray[el.id] = el.data[0] + el.data[1];
          this.dataByAgeNoGender(video);
          this.dataByGender(video);
          this.dataByAge(video);
          if (el.data[0] > saida.tick) {
            saida.tick = el.data[0];
          }
          if (el.data[1] > saida.tick) {
            saida.tick = el.data[1];
          }
        });
        // console.log(this.barDataArray);
        // saidaArray.push(JSON.parse(JSON.stringify(saida)));
        // console.log(saidaArray);
        // this.pyramidTitle = saidaArray[0].title;
        // this.pyramidData = saidaArray[0].data;
        // console.log(saidaArray[0]);
        // this.pyramidTick = saidaArray[0].tick;
        // this.dataMidia = true;
      });
    },    
    dataByAgeNoGender(video) {
      var labels = [];
      var data = Array(this.ageRanges.length).fill(0);
      // console.log(data);

      video.viewData.forEach(range => {
        labels.push(range.label);
      });

      var output = {
        labels: labels,
        datasets: [
          {
            label: "Acessos",

            data: this.barDataArray
          }
        ]
      };
      this.barData = output;

      // console.log(output);

      // return output;
    },
    dataByGender(video) {
      var labels = ["Masculino", "Feminino", "Não Informado / Outros"];
      let arrayData = [0, 0, 0];
      let soma = 0;

      for (let index = 0; index < arrayData.length; index++){
        for (let i = 0; i < video.viewData.length; i++){
          soma = soma + video.viewData[i].data[index];
          console.log(video.viewData[i].data[index]);
        }
        arrayData[index] = soma;
      }

      console.log(arrayData);

      this.pieData = {
        labels: labels,
        data: arrayData
      };
    },
    dataByAge(video) {
      let labels = [];
      let arrayData = [
        {
            label: "Masculino",
            data: []
          },
          {
            label: "Feminino",
            data: []
          },
          {
            label: "Não Informado / outros",
            data: []
          }
      ];

      for (let index = 0; index < arrayData.length; index++){
        for (let i = 0; i < video.viewData.length; i++){
          arrayData[index].data.push(video.viewData[i].data[index]);
        }
      }
      
      video.viewData.forEach(element => {
        labels.push(element.label)
      });

      this.barAgeData = {
      labels: labels,
      datasets: arrayData
    };
    },

    getAllCampaigns() {
      moment.updateLocale("pt", {
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez"
        ]
      });
      ws.getCampaigns(this.getController_id()).then(response => {
        const data = response.data;
        const startPeriod = new Date(this.selectDates[0]);
        const endPeriod = new Date(this.selectDates[1]);
        let campaigns = [];
        let endDate;
        let startDate;
        let objQuantity;
        let sum;

        //campanhas por periodo

        data.forEach(element => {
          endDate = new Date(element.end_date);
          startDate = new Date(element.start_date);

          if (
            element.end_date !== null &&
            element.start_date !== null &&
            endDate >= startPeriod &&
            startDate <= endPeriod
          ) {
            if (element.viewData) {
              objQuantity = element.viewData;

              sum = 0;
              objQuantity.forEach(elementData => {
                sum += elementData.data.reduce(
                  (previousValue, currentElement) => {
                    return previousValue + currentElement;
                  }
                );
              });
              element["sum"] = sum;
              campaigns.push(element);
            }
          }
        });

        //ordenando por data de criação

        campaigns.sort((a, b) => {
          let x = new Date(a.timeCreated);
          let y = new Date(b.timeCreated);
          return y - x;
        });

        let doneCampains = [];
        let finishedCampains = [];

        //pegando as ativas
        let activeCampaigns = campaigns.filter(element => {
          let auxActiveToday =
            new Date(element.end_date).getTime() >= new Date().getTime()
              ? true
              : false;
          element["activeToday"] = auxActiveToday;
          element.timeCreated = moment(element.timeCreated).format(
            "DD [de] MMMM YYYY"
          );
          element.start_date = moment(element.start_date).format("DD/MM/YYYY");
          element.end_date = moment(element.end_date).format("DD/MM/YYYY");
          element.name = element.name[0] + element.name.substr(1).toLowerCase();

          if (
            auxActiveToday &&
            element.is_active === true &&
            (element.show_qt > sum ||
              element.show_qt === null ||
              element.show_qt === undefined)
          ) {
            return element;
          } else if (
            auxActiveToday &&
            element.is_active === false &&
            (element.show_qt > sum ||
              element.show_qt === null ||
              element.show_qt === undefined)
          ) {
            doneCampains.push(element);
          } else {
            finishedCampains.push(element);
          }
        });
        this.campaigns = [
          ...activeCampaigns,
          ...doneCampains,
          ...finishedCampains
        ].splice(0, 4);
      });
    },

    //essa função tem q ser feita no back
    //TODO averiguar se de fato a lógica contempla todas as campanhas ativas momento
    getAllActiveCampaigns() {
      ws.getActiveCampaigns(this.getController_id()).then(response => {
        let today = moment().format("YYYY-MM-DD");
        let activeCampaigns = [];
        response.data.forEach(element => {
          let endDay = moment(element.end_date).format("YYYY-MM-DD");
          let startDay = moment(element.start_date).format("YYYY-MM-DD");

          if (
            moment(endDay).isAfter(today) &&
            element.end_date !== null &&
            moment(startDay).isBefore(today)
          ) {
            if (element.show_qt) {
              if (element.show_qt !== null) {
                let objQuantity = element.view_data; //somando objetos do view_data guardando em sum
                let sum = 0;
                objQuantity.forEach(elementData => {
                  sum += elementData.data.reduce(
                    (previousValue, currentElement) => {
                      return previousValue + currentElement;
                    }
                  );
                });
                if (element.show_qt >= sum) {
                  activeCampaigns.push(element);
                }
              } else {
                activeCampaigns.push(element);
              }
            } else {
              activeCampaigns.push(element);
            }
          }
        });

        this.realTimeCampaigns = activeCampaigns;
      });
    },
    getAps() {
      ws.getRadiosByRadioPrefix(this.getRadioPrefix)
        .then(res => {
          let totalApsOnline = [];
          this.realTimeTotalAps = res.data;
          let aux = 0;
          res.data.forEach(element => {
            if (element.offline === 0) {
              totalApsOnline[aux] = element;
              aux++;
            }
          });
          this.realTimeApsOnline = totalApsOnline;
          aux = 0;
          totalApsOnline = [];
        })
        .catch(err => {
          console.log(err);
        });
    },

    //TODO testar a quantidade de informações rotas
    getDetecteds() {
      if (this.clientHasMap === true) {
        ws.getLastSensored(store.state.client.idVagalox)
          .then(res => {
            let date = Date.parse(res.data[0].ts);

            if (moment(date).isSameOrAfter(moment().subtract(5, "minute"))) {
              this.realTimeController.detecteds = true;
            } else {
              this.realTimeController.detecteds = false;
            }
            this.realTimeDetecteds[0] = res.data[0].Total_Stations;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    getDate(qtDays = 0) {
      var saida = moment();

      if (qtDays < 0) saida = moment().subtract(-qtDays, "days");
      else if (qtDays > 0) saida = moment().add(qtDays, "days");

      return saida;
    },

    selectDate() {
      //aqui para que pudessemos fazer a granularidade funcionar sem precisar fazer várias requisições, trabalhamos com o pior caso que seria levar em conta a granularidade mensal onde o mês
      //começa em uma terça e acaba em uma segunda, oq nos levar a sempre pegar o mês inteiro e add 6 dias para frentes e para trás.
      console.log(this.dates);
      this.selectDates[0] = moment(this.dates[0]);
      this.selectDates[1] = moment(this.dates[1]);
      const today = moment().format("YYYY-MM-DD");''
      const startOfMonth = moment(this.selectDates[0]).startOf("month");
      const endOfMonth = moment(this.selectDates[1]).endOf("month");
      const endDate = moment(endOfMonth)
        .add(6, "days")
        .format("YYYY-MM-DD");
      this.dateSD = moment(startOfMonth)
        .subtract(6, "days")
        .format("YYYY-MM-DD");

      if (moment(today).isBefore(endDate)) {
        this.dateED = moment(today).format("YYYY-MM-DD");
      } else {
        this.dateED = moment(endDate).format("YYYY-MM-DD");
      }

      this.filtrar();
    },

    dateConverter(date) {
      if (date[0]) {
        return (
          date[0].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          }) +
          " - " +
          date[1].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          })
        );
      }
    },

    loadOnlineData() {
      // this.realTimeDevices = 0;
      // this.realTimeOnline = 0;
      // if (this.getRadioPrefix) {
      //   var radioPrefix = this.getRadioPrefix.toLowerCase();

      //   ws.getOnlineStatus(radioPrefix).then(response => {
      //     this.realTimeOnline = response.data[0].totalonline;

      //     this.realTimeDevices = response.data[0].totaldevices;

      //     if (this.debug_mode == 2) console.log("we have online data!");
      //     if (this.debug_mode == 2) console.log(response.data[0]);
      //   });
      // }
    },
    loadOnlineGroupData() {
      var dateSD = moment()
        .subtract(this.settings.periodo, "hours")
        .toISOString(true);
      var dateED = moment().toISOString(true);
      let radio_prefix_list = [];
      for (let client of store.state.group_selected_clients) {
        radio_prefix_list.push('"' + client.radio_prefix + '"');
      }

      ws.getOnlineGroupStatus(radio_prefix_list, dateSD, dateED).then(
        response => {
          this.count_here_group = 0;
          for (let client of store.state.group_selected_clients) {
            var teste = response.data.find(
              element => element.clientname == client.radio_prefix
            );
            if (teste) {
              this.count_here_group++;
            }
          }
          this.onlineData = response.data.map(el => ({
            datetime: el.datetime,
            online:
              parseInt(el.totalonline) *
              (this.count_here_group + this.count_here_group / 4),
            devices:
              parseInt(el.totaldevices) *
              (this.count_here_group + this.count_here_group / 4),
            clientname: el.clientname
          }));
        }
      );
    },
    loadGeneralGroupData() {
      const concat = require("array-concat-sum");
      let client_id_list = [];
      let client_controller_id_list = [];
      for (let client of store.state.group_selected_clients) {
        if (client.id != "all") {
          client_id_list.push(client.id);
          client_controller_id_list.push(client.controller_id);
        }
      }
      const formatDate = "YYYY/MM/DD";
      var startDate = this.dateSD;
      var endDate = this.dateED;
      var today = moment().format(formatDate);
      var data_summary = [];
      this.isLoadingAuthenticated = true;
      this.isLoading = true;

      var dates = getDates(startDate, endDate, formatDate);

      var datesSearch = dates.slice(0);

      var p1 = new Promise(resolve => {
        var index = 0;
        ws.getGroupSummary(
          client_id_list,
          startDate.replace(/\-/g, "/"),
          endDate.replace(/\-/g, "/")
        ).then(response => {
          response.data.forEach(el => {
            if (!data_summary.some(el2 => el2.datetime == el.datetime)) {
              //data_summary.push(el);
            }
          });

          data_summary.forEach(el => {
            var cursor = moment(el.datetime).format(formatDate);
            if (dates.includes(cursor)) {
              datesSearch.splice(datesSearch.indexOf(cursor), 1);
            }
          });

          if (datesSearch.length == 0) {
            resolve(data_summary);
          }

          datesSearch.forEach(el => {
            ws.getConnectionsByClientGroupIdDates(
              client_id_list, //pei
              el,
              moment(el)
                .add(1, "days")
                .format(formatDate)
            ).then(response2 => {
              var obj = {
                datetime: el,
                client_id: "genérico", //pei
                age_ranges: [
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0]
                ]
              };
              // var macs = [];

              // var f = 0;
              // var m = 0;
              // var na = 0;
              // response2.data.forEach(conn => {
              //   var user = conn.userAuth;

              //   if (!!user && typeof user == "object") {
              //     if (!macs.includes(user.mac)) {
              //       macs.push(user.mac);

              //       if (user.hasOwnProperty("birth_date")) {
              //         var birth_date = user.birth_date;

              //         if (isNaN(new Date(birth_date).getTime())) {
              //           birth_date = birth_date
              //             .split("/")
              //             .reverse()
              //             .join("/");
              //         }
              //         getClient_id();

              //         var age = moment().diff(birth_date, "years");
              //         var found = false;

              //         for (var i = 0; i < this.ageRanges.length - 1; i++) {
              //           if (
              //             age >= this.ageRanges[i].limits[0] &&
              //             age < this.ageRanges[i].limits[1]
              //           ) {
              //             found = true;

              //             if (user.hasOwnProperty("gender")) {
              //               if (user.gender === "m" || user.gender === "M") {
              //                 obj.age_ranges[i][0] = obj.age_ranges[i][0] + 1;
              //                 m++;
              //               } else if (
              //                 user.gender === "f" ||
              //                 user.gender === "F"
              //               ) {
              //                 obj.age_ranges[i][1] = obj.age_ranges[i][1] + 1;
              //                 f++;
              //               } else {
              //                 obj.age_ranges[i][2] = obj.age_ranges[i][2] + 1;
              //                 na++;
              //               }
              //             } else {
              //               obj.age_ranges[i][2] = obj.age_ranges[i][2] + 1;
              //               na++;
              //             }
              //           }
              //         }

              //         if (!found) {
              //           if (user.gender) {
              //             if (user.gender === "m" || user.gender === "M") {
              //               obj.age_ranges[this.ageRanges.length - 1][0] =
              //                 obj.age_ranges[this.ageRanges.length - 1][0] + 1;
              //               m++;
              //             } else if (
              //               user.gender === "f" ||
              //               user.gender === "F"
              //             ) {
              //               obj.age_ranges[this.ageRanges.length - 1][1] =
              //                 obj.age_ranges[this.ageRanges.length - 1][1] + 1;
              //               f++;
              //             } else {
              //               obj.age_ranges[this.ageRanges.length - 1][2] =
              //                 obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //               na++;
              //             }
              //           } else {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           }
              //         }
              //       } else {
              //         if (user.hasOwnProperty("gender")) {
              //           if (user.gender === "m" || user.gender === "M") {
              //             obj.age_ranges[this.ageRanges.length - 1][0] =
              //               obj.age_ranges[this.ageRanges.length - 1][0] + 1;
              //             m++;
              //           } else if (user.gender === "f" || user.gender === "F") {
              //             obj.age_ranges[this.ageRanges.length - 1][1] =
              //               obj.age_ranges[this.ageRanges.length - 1][1] + 1;
              //             f++;
              //           } else {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           }
              //         } else {
              //           try {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           } catch (err) {}
              //         }
              //       }
              //     }
              //   }
              // });

              data_summary.push(obj);

              index++;

              if (index == datesSearch.length) {
                resolve(data_summary);
              }
            });
          });
          this.data_news = [];
          ws.getConnectionsByClientIdDatesGroup(
            store.state.group_selected.text,
            startDate.replace(/\-/g, "-"),
            endDate.replace(/\-/g, "-")
          ).then(response => {
            if (this.data_news.length != undefined) {
              this.data_news = response.data;
            } else {
              this.data_news.data = concat(
                this.data_news.data,
                response.data.data
              );
            }
          });
        });
      });

      p1.then(res => {
        if (res) {
          this.data_summary = res;

          this.data_summary.sort(function(a, b) {
            return a.datetime <= b.datetime ? -1 : 1;
          });

          this.isLoadingAuthenticated = false;
        }
      });
    },
    async loadGeneralData() {
      if (this.debug_mode == 1)
        console.log("loadIterations: ", this.loadIterations);
      const formatDate = "YYYY/MM/DD";
      var startDate = this.dateSD;
      var endDate = this.dateED;
      var today = moment().format(formatDate);
      var evalToday = false;
      var data_summary = [];

      //nunca calcular dias maiores q hoje
      if (endDate > today) endDate = today;

      var dates = getDates(startDate, endDate, formatDate);
      var datesSearch = dates.slice(0);

      if (datesSearch.at(-1) == today) {
        evalToday = true;
      }

      const call = async () => {
        var index = 0;
        if (store.state && store.state.client) {
          //skip

          //nao precisamos ficar atualizando os sumarios de dias anteriores pra sempre
          //if (this.loadIterations >0){

          var summaryStartDate = startDate;
          var summaryEndDate = endDate;

          if (this.debug_mode == 1) console.log(datesSearch);
          if (this.debug_mode == 1)
            console.log("summaryEndDate = ", summaryEndDate);
          if (this.debug_mode == 1)
            console.log("summaryStartDate = ", summaryStartDate);
          if (this.debug_mode == 1) console.log("evalToday = ", evalToday);
          
          data_summary = await this.getSummarybyDate(
            summaryStartDate,
            summaryEndDate
          );

          if (this.debug_mode == 1) console.log(data_summary);
          data_summary.forEach(el => {
            datesSearch = this.filterSummary(el, dates, datesSearch);

            if (datesSearch.length === 0) return data_summary;
          });

          if (datesSearch.length > 0) {
            // data_summary = await this.summaryGenerator(data_summary, datesSearch);
            console.log("Dias pendentes.")
          }

          return data_summary;
        }
      };

      call().then(res => {
        if (res) {
          this.data_summary = res;
          this.data_summary.sort(function(a, b) {
            return a.datetime <= b.datetime ? -1 : 1;
          });

          if (data_summary.length > 0){
            console.log(data_summary);
            this.dataByPeriod();
          }

          this.isLoadingAuthenticated = false;
        }
      });
    },
    filtrar() {
      this.data_news.data = [];
      this.data_summary = [];
      this.isLoadingAuthenticated = true;
      
      this.getSummarynewAuthentication().then(this.loadGeneralData());
      
      // this.totalApsByPeriod();
      // this.getAllCampaigns();
      this.loadIterations++;
    },

    total(chartData) {
      var saida = 0;

      chartData.datasets.forEach(ds => {
        if (ds.label != "Novos") {
          if (ds.data.length) {
            saida += ds.data.reduce((acc, curr) => acc + Math.abs(curr));
          }
        }
      });

      return saida.toLocaleString("pt-BR");
    },

    totalApsByPeriod() {
      const startDate = moment(this.selectDates[0]).format("YYYY-MM-DD");
      const endDate = moment(this.selectDates[1]).format("YYYY-MM-DD");

      ws.getApsByPeriod(this.getController_id(), startDate, endDate).then(
        response => {
          this.topAps = response.data;
        }
      );

      ws.getRadiosByRadioPrefix(store.state.client.radio_prefix).then(
        response => {
          this.radios = response.data;
        }
      );
    },

    async getSummarynewAuthentication() {
      var startDate = this.dateSD;
      var endDate = this.dateED;
      // await ws
      //   .getNewUserByClientIdDates(
      //     this.getController_id(),
      //     startDate.replace(/\-/g, "-"),
      //     endDate.replace(/\-/g, "-")
      //   )
      //   .then(response => {
      //     this.data_news = response.data;
      //     this.dataNewsAux = true;
      //   })
      //   .catch(err => {});
    },
    //responsável por puxar os sumários das datas e tirar as repetidas
    async getSummarybyDate(startDate, endDate) {
      var data = [];
      const response = await ws
        .getSummary(this.getController_id(), startDate, endDate)
        .then(response => {
          console.log("response: ", response);
          if (this.debug_mode == 1)
            console.log("response summary date: ", response.data.length);
          response.data.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.datetime) - new Date(b.datetime);
          });
          if (this.debug_mode == 1) console.log(response);

          //carrega data com 1 sumario de cada data. Se houver data repetida no sumario, nao será utilizada

          response.data.forEach(el => {
            if (!data.some(el2 => el2.datetime == el.datetime)) {
              data.push(el);
              if (this.debug_mode == 1) console.log(el);
            } else {
              if (this.debug_mode == 1) console.log("hein?");
            }
          });
          if (this.debug_mode == 1) console.log(data);
          return data;
        });
      return response;
    },
    //responsável por filtrar quais datas já possuem sumário e quais ainda não possuem
    filterSummary(element, datesSummary, datesSearch) {
      const formatDate = "YYYY/MM/DD";
      var sum = 0;

      element.age_ranges.forEach(el => {
        sum += el.reduce((previousValue, currentElement) => {
          return previousValue + currentElement;
        });
      });

      var cursor = moment(element.datetime).format(formatDate);
      if (datesSummary.includes(cursor)) {
        if (this.debug_mode == 1) console.log(datesSearch);
        datesSearch.splice(datesSearch.indexOf(cursor), 1);
      } else {
      }

      if (this.debug_mode == 1) console.log(datesSearch);
      //se todas as datas ja possuirem sumario, resolve a promise

      return datesSearch;
    },
    //gerar os sumários para datas que não possuem
    async summaryGenerator(data, datesSearch) {
      const formatDate = "YYYY/MM/DD";

      var today = moment().format(formatDate);
      var endDate = moment(this.dateED).format(formatDate);
      if (moment(endDate).isAfter(today)) {
        endDate = today;
      }
      

      var dataSummary = data;
      await Promise.all(
        datesSearch.map(async el => {
          await ws
            .getConnectionsByClientIdDates(
              this.getClient_id(),
              el,
              moment(el)
                .add(1, "days")
                .format(formatDate)
            )
            .then(response2 => {
              
              var obj = {
                datetime: el,
                client_id: this.getClient_id(),
                age_ranges: [
                  //TODO criar array de acordo com quantos ranges existem e TODO2 deixar dinamico de acordo com cliente
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0],
                  [0, 0, 0]
                ]
              };

              // var macs = [];
              // var index = 0;
              // var f = 0;
              // var m = 0;
              // var na = 0;
              // var today = moment().format(formatDate);
              
              // response2.data.forEach(conn => {
                
              //   var user = conn.userAuth;

              //   if (!!user && typeof user == "object") {
              //     if (!macs.includes(user.mac)) {
              //       macs.push(user.mac);
 
              //       if (user.hasOwnProperty("birth_date")) {
              //         var birth_date = user.birth_date;

              //         if (isNaN(new Date(birth_date).getTime())) {
              //           birth_date = birth_date
              //             .split("/")
              //             .reverse()
              //             .join("/");
              //         }
              //         //TODO atualizar idade periodicamente dos sumarios antigos, e compensar os sumarios quando forem calculados depois de um ano

              //         var age = moment().diff(birth_date, "years");
              //         var found = false;

              //         for (var i = 0; i < this.ageRanges.length - 1; i++) {
              //           if (
              //             age >= this.ageRanges[i].limits[0] &&
              //             age < this.ageRanges[i].limits[1]
              //           ) {
              //             found = true;

              //             if (user.hasOwnProperty("gender")) {
              //               if (user.gender === "m" || user.gender === "M") {
              //                 obj.age_ranges[i][0] = obj.age_ranges[i][0] + 1;
              //                 m++;
              //               } else if (
              //                 user.gender === "f" ||
              //                 user.gender === "F"
              //               ) {
              //                 obj.age_ranges[i][1] = obj.age_ranges[i][1] + 1;
              //                 f++;
              //               } else {
              //                 obj.age_ranges[i][2] = obj.age_ranges[i][2] + 1;
              //                 na++;
              //               }
              //             } else {
              //               obj.age_ranges[i][2] = obj.age_ranges[i][2] + 1;
              //               na++;
              //             }
              //             continue; //skip for after finding
              //           }
              //         }
              //         //TODO por o range do ultimo elemento para infinito e tirar este bloco debaixo completamente
              //         //spoiler. a maior idade ja eh 120 e tem um age range q eh de nao informado. pra que este bloco debaixo?
              //         if (!found) {
              //           if (user.gender) {
              //             if (user.gender === "m" || user.gender === "M") {
              //               obj.age_ranges[this.ageRanges.length - 1][0] =
              //                 obj.age_ranges[this.ageRanges.length - 1][0] + 1;
              //               m++;
              //             } else if (
              //               user.gender === "f" ||
              //               user.gender === "F"
              //             ) {
              //               obj.age_ranges[this.ageRanges.length - 1][1] =
              //                 obj.age_ranges[this.ageRanges.length - 1][1] + 1;
              //               f++;
              //             } else {
              //               obj.age_ranges[this.ageRanges.length - 1][2] =
              //                 obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //               na++;
              //             }
              //           } else {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           }
              //         }
              //       } else {
              //         if (user.hasOwnProperty("gender")) {
              //           if (user.gender === "m" || user.gender === "M") {
              //             obj.age_ranges[this.ageRanges.length - 1][0] =
              //               obj.age_ranges[this.ageRanges.length - 1][0] + 1;
              //             m++;
              //           } else if (user.gender === "f" || user.gender === "F") {
              //             obj.age_ranges[this.ageRanges.length - 1][1] =
              //               obj.age_ranges[this.ageRanges.length - 1][1] + 1;
              //             f++;
              //           } else {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           }
              //         } else {
              //           try {
              //             obj.age_ranges[this.ageRanges.length - 1][2] =
              //               obj.age_ranges[this.ageRanges.length - 1][2] + 1;
              //             na++;
              //           } catch (err) {}
              //         }
              //       }
              //     }
              //   }
              // });
              // if (this.debug_mode == 1) console.log(el)
              // if (this.debug_mode == 1) console.log(obj)
              // if (moment(endDate).isSame(today)) {
              //   if (
              //     !moment(dataSummary[dataSummary.length - 1].datetime).isSame(
              //       today
              //   ) {
              //     dataSummary.push(obj);
              //   }
              // }

              // if (this.debug_mode == 1) console.log(dataSummary);
              // dataSummary.forEach((el, index) => {
              //   if (el.datetime == obj.datetime) {
              //     dataSummary.splice(index, 1, obj);
              //   }
              // });
              // if (this.debug_mode == 1) console.log(obj);
              // if (obj.datetime != today) {
              //   ws.postSummary(obj).then(() => {
              //     if (this.debug_mode == 1)
              //       console.log("Salvo sumario do dia ", obj.datetime);
              //   });
              // }

              index++;

              if (index == datesSearch.length) {
                return dataSummary;
              }
            })
            .catch(err => {});
        })
      );

      return dataSummary;
    }
  },
  watch: {
    /* dateSD() {
      if (this.dateSDDirty) {
        this.filtrar();
      }
      this.dateSDDirty = true;
    },
    dateED() {
      if (this.dateEDDirty) {
        this.filtrar();
      }
      this.dateEDDirty = true;
    }, */

    settings: {
      deep: true,
      handler(newValue) {
        this.loadOnlineData();
      }
    },
    getGroupID(newValue) {
      this.onlineData = [];
      this.data_summary = [];
      this.realTimeDevices = 0;
      this.realTimeOnline = 0;
      //TODO revisar trecho de código para saber se ainda é necessário
      /*
      ws.getQuestions(newValue).then(response => {
        this.rawQuestions = response.data;

        this.loadQuestions();
      });

      this.loadOnlineGroupData();
      this.loadGeneralGroupData();
      ws.getClientFields(this.getID).then(response => {
        this.fields = response.data.fields.filter(
          el => el.type != "label" && el.is_active
      );
      this.fields =  this.fields.map(el => el.name);

      });
*/
      /*
       */
    },
    getControllerId(newValue) {
      this.onlineData = [
        {
          datetime: "",
          online: 0,
          devices: 0
        }
      ];
      this.realTimeCampaigns = [];
      this.data_summary = [];
      this.aps = {
        avarage: [],
        name: []
      };
      this.dataNewsAux = false;
      this.isLoadingAuthenticated = true;

      if (newValue == "all") {
        this.loadOnlineGroupData();
        this.loadGeneralGroupData();
      } else {
        this.loadOnlineData();
        this.loadIterations = 0;
        this.dates = [
          moment()
            .subtract(6, "d")
            .toDate(),
          moment().toDate()
        ];

        this.selectDate();
        /*   ws.getQuestions(newValue).then(response => {
          this.rawQuestions = response.data;

          this.loadQuestions();
        });
 */

        // this.getAllActiveCampaigns();
        // this.getAllCampaigns();
        // this.getAps();
        // this.getDetecteds();
        // this.totalApsByPeriod();
        ws.getClientFields(this.getID)
          .then(response => {
            this.fields = response.data.fields.filter(
              el => el.type != "label" && el.is_active
            );

            //this.fields.push({ type: "string", name: "mac", label: "MAC" });
            //console.log(this.fields)
            this.fields = this.fields.map(el => el.name);
          })
          .catch(err => {});
      }
    }
  },
  computed: {
    ...mapGetters([
      "ageRanges",
      "getID",
      "getClientID",
      "getControllerId",
      "getGroupID",
      "getGroupClients",
      "getToken",
      "getRadioPrefix",
      "getClientCoordinates",
      "isMapActive"
    ]),
    clientHasMap() {
      return store.state.client && store.state.client.coordinates != null;
    },

    activeCampaignsRealTime() {
      var output = this.realTimeCampaigns;
      return output;
    },

    topApsByPeriod() {
      let aps = {
        avarage: [],
        nome: []
      };

      let apsId = [];
      let totalAvarage = [];
      let apsName = [];
      let apsNameComplete;
      let totalAps = [];
      let topApsInfoUnordered = [];
      let topApsInfo;

      if (this.topAps.length > 1) {
        this.topAps.sort((a, b) => {
          if (!a.periodAverage) return 1;
          if (!b.periodAverage) return 1;
          if (a.periodAverage > b.periodAverage) return -1;
          if (a.periodAverage < b.periodAverage) return 1;
          return 0;
        });

        for (let aux = 0; aux < 7; aux++) {
          totalAps[aux] = this.topAps[aux];
        }

        totalAps.forEach((element, index) => {
          totalAvarage[index] = element.periodAverage;
          apsId[index] = element.ap_id;
        });

        topApsInfoUnordered = this.radios.filter(element =>
          apsId.includes(element.ip)
        );

        topApsInfo = apsId.map(el => {
          for (let i = 0; i < topApsInfoUnordered.length; i++) {
            if (topApsInfoUnordered[i].ip === el) return topApsInfoUnordered[i];
          }
        });

        topApsInfo.forEach((element, index) => {
          if (element !== undefined) {
            if (element.name.indexOf("--") > -1) {
              apsNameComplete = element.name.split("--");
            } else {
              apsNameComplete = element.name.split("_");
            }

            apsName[index] = apsNameComplete[1];
          }
        });

        return (aps = {
          avarage: totalAvarage.map(el => {
            return `${(el * 100).toFixed(2)}%`;
          }),
          name: apsName.map((el, index) => {
            return `${index + 1} - ${el}`;
          })
        });
      } else {
        return (aps = {
          avarage: [],
          name: []
        });
      }
    },

    segdataDevices() {
      var output;

      output = this.realTimeDevices;

      return output;
    },
    segdataOnline() {
      var output;

      output = this.realTimeOnline;

      return output;
    }
  }
};

function getDates(start_date, end_date, format = "D/M") {
  var startDate = moment(start_date);
  var endDate = moment(end_date);
  var dayDiff = endDate.diff(startDate, "days") + 1;
  if (!dayDiff) {
    dayDiff = 0;
  }

  var saida = Array(dayDiff).fill(null);
  var cursor = startDate.clone();
  saida.forEach((i, k) => {
    saida[k] = cursor.format(format);

    cursor.add(1, "d");
  });

  return saida;
}
</script>

<style>
  .print-area-styles {
    height: 150px;
    background-color: #ff9801 !important; 
    padding: 20px;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact !important;
}
  .logo-div {
    background-color: white; 
    width: 120px; 
    height: 100px; 
    margin: auto; 
    text-align: center; 
    padding: 10px; 
    border-radius: 5px;
  }

  .graficos {
    margin-bottom: 20px;
    max-width: 740px;
    max-height: 350px;
    
  }

  .top-info {
    position: absolute; 
    top: 6vh; 
    left: 20vw;
    color: rgb(73, 71, 71);
    font-size: 14px;
    font-weight: bold;
  }

    .top-info-2 {
    position: absolute; 
    top: 8vh; 
    left: 20vw;
    color: rgb(73, 71, 71);
    font-size: 14px;
    font-weight: bold;
  }

  .top-info-user {
    position: absolute; 
    top: 10vh; 
    left: 20vw;
    color: rgb(73, 71, 71);
    font-size: 14px;
    font-weight: bold;
  }

  .top-graficos {
    page-break-before: avoid;
  }
  
  .graficos-mes {
    margin-top: 20px;
    max-width: 740px;
    page-break-before: always;
  }

@media print {
  .print-area-styles {
    height: 150px;
    background-color: #ff9801 !important;
    padding: 20px;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact !important;
}
  .logo-div {
    background-color: white; 
    width: 120px; 
    height: 100px; 
    margin-top: 50px;
    text-align: center; 
    padding: 20px; 
    border-radius: 5px;
  }

  .top-info {
    position: absolute; 
    top: 20px; 
    left: 150px;
    color: rgb(73, 71, 71);
    font-size: 12px;
    font-weight: bold;
  }

    .top-info-2 {
    position: absolute; 
    top: 40px; 
    left: 150px;
    color: rgb(73, 71, 71);
    font-size: 12px;
    font-weight: bold;
  }

    .top-info-user {
    position: absolute; 
    top: 60px; 
    left: 150px;
    color: rgb(73, 71, 71);
    font-size: 12px;
    font-weight: bold;
  }

    .graficos {
    margin-bottom: 20px;
    max-width: 100px;
  }

  .top-graficos {
    page-break-before: avoid;
  }

  .top-datepicker {
    visibility: hidden;
  }

  @page {
    size: auto;   /* auto is the initial value */
    margin: 0;  /* this affects the margin in the printer settings */
}
}

</style>


// WEBPACK FOOTER //
// src/components/Relatorios.vue